// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"44df1727","62":"d7ff4b95","181":"44df1727","206":"4cde393f","331":"05773f33","399":"515f3f93","427":"44df1727","589":"44df1727","887":"515f3f93"}[chunkId] + ".chunk.css";
};